/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuthorityType } from './authority-type';
import { ServizioCompactDTO } from './servizio-compact-dto';


export interface OperatoreServizioMensaDTO { 
    id?: string;
    email?: string;
    nome?: string;
    cognome?: string;
    account_enabled?: boolean;
    account_activated?: boolean;
    invito_in_attesa?: boolean;
    authorities?: Set<AuthorityType>;
    ruolo?: OperatoreServizioMensaDTORuoloEnum;
    servizi_assegnati?: Array<ServizioCompactDTO>;
}
export enum OperatoreServizioMensaDTORuoloEnum {
    OP_SCUOLA = 'OP_SCUOLA',
    OP_CENTRO_COTTURA = 'OP_CENTRO_COTTURA'
};



